import clsx from 'clsx';

const regions = [
  // NYC Boroughs
  { value: 'Manhattan', label: 'Manhattan', group: 'NYC' },
  { value: 'Brooklyn', label: 'Brooklyn', group: 'NYC' },
  { value: 'Queens', label: 'Queens', group: 'NYC' },
  { value: 'Bronx', label: 'Bronx', group: 'NYC' },
  { value: 'Staten Island', label: 'Staten Island', group: 'NYC' },
  // New Jersey
  { value: 'Hudson County', label: 'Hudson County', group: 'NJ' },
  // Connecticut
  { value: 'Connecticut', label: 'Connecticut', group: 'CT' },
  // Philadelphia
  { value: 'Philadelphia', label: 'Philadelphia', group: 'PA' },
];

const regionGroups = ['NYC', 'NJ', 'CT', 'PA'] as const;

interface RegionFilterProps {
  selected: string[];
  onChange: (regions: string[]) => void;
}

export function RegionFilter({ selected, onChange }: RegionFilterProps) {
  const toggleRegion = (region: string) => {
    if (selected.includes(region)) {
      onChange(selected.filter((r) => r !== region));
    } else {
      onChange([...selected, region]);
    }
  };

  const toggleGroup = (group: string) => {
    const groupRegions = regions.filter((r) => r.group === group).map((r) => r.value);
    const allSelected = groupRegions.every((r) => selected.includes(r));

    if (allSelected) {
      onChange(selected.filter((r) => !groupRegions.includes(r)));
    } else {
      const newSelected = new Set([...selected, ...groupRegions]);
      onChange(Array.from(newSelected));
    }
  };

  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-font-primary">Region</label>

      {regionGroups.map((group) => {
        const groupRegions = regions.filter((r) => r.group === group);
        const allSelected = groupRegions.every((r) => selected.includes(r.value));
        const someSelected = groupRegions.some((r) => selected.includes(r.value));

        return (
          <div key={group} className="space-y-1.5">
            <button
              onClick={() => toggleGroup(group)}
              className={clsx(
                'text-xs font-semibold uppercase tracking-wide',
                someSelected ? 'text-brand-primary' : 'text-font-secondary'
              )}
            >
              {group}
              {allSelected && <span className="ml-1 text-brand-secondary">All</span>}
            </button>
            <div className="flex flex-wrap gap-1.5">
              {groupRegions.map((region) => {
                const isSelected = selected.includes(region.value);
                return (
                  <button
                    key={region.value}
                    onClick={() => toggleRegion(region.value)}
                    className={clsx(
                      'px-2.5 py-1 rounded-md text-sm transition-colors',
                      isSelected
                        ? 'bg-brand-primary text-white'
                        : 'bg-white text-font-secondary border border-card-border hover:border-brand-primary'
                    )}
                  >
                    {region.label}
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
